import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './components/MappedComponents';
import { Constants } from '@adobe/aem-spa-page-model-manager';
import { Container } from '@adobe/aem-react-editable-components';

const ID_ATTRIBUTE = 'data-cq-id';

function recursiveFind(componentType, cqId, object, name) {
  if (!object) {
    return null;
  }

  const { ':type': type, id } = object;

  if (type === componentType && id === cqId) {
    // create a shallow copy, and use the name of the item as the name
    return { [name]: { ...object } };
  }

  const items = object?.[Constants.ITEMS_PROP] ?? {};

  return Object.entries(items) //
    .map(([childName, child]) => recursiveFind(componentType, cqId, child, childName))
    .find((item) => !!item);
}

export default {
  init(store, domEl, model) {
    const root = createRoot(domEl);
    const rootObject = model[Constants.ITEMS_PROP]?.root;
    const componentType = domEl.getAttribute('data-cq-type');
    const cqId = domEl.getAttribute(ID_ATTRIBUTE);
    const cqItems = recursiveFind(componentType, cqId, rootObject, 'root') ?? {};
    // Assumption: there will only be one item/key in cqItems
    const cqItemsOrder = Object.keys(cqItems);

    root.render(
      <Provider store={store}>
        <Container cqItems={cqItems} cqItemsOrder={cqItemsOrder} />
      </Provider>
    );
  },
};
